import { Alert } from '@mui/material';
import { useMemo } from 'react';

export interface AggregatedAlertsProps {
    alertList: AlertList[];
}

export interface AlertList {
    alertId: number;
    severity: 'error' | 'warning' | 'info' | 'success';
    message: string;
}

export const AggregatedAlerts = ({ alertList }: AggregatedAlertsProps) => {
    let severitySortedAlerts = useMemo(
        () =>
            alertList.sort((a, b) => {
                if (a.severity === 'error') return -1;
                if (b.severity === 'error') return 1;
                if (a.severity === 'warning') return -1;
                if (b.severity === 'warning') return 1;
                if (a.severity === 'info') return -1;
                if (b.severity === 'info') return 1;
                return 0;
            }),
        [alertList]
    );

    return (
        <div>
            {severitySortedAlerts.map((alert) => {
                return (
                    <Alert
                        key={alert.alertId}
                        sx={{
                            marginTop: '1rem',
                            width: '100%'
                        }}
                        severity={alert.severity}
                    >
                        {alert.message}
                    </Alert>
                );
            })}
        </div>
    );
};
